export default {
    configuration: false,
    searchList: {
        searchTxt: [
            // {
            //     name: '供应商',
            //     advanceLabel: '供应商',
            //     value: 'carrierName',
            //     advanceConfig: [
            //         { prop: 'supplierNameCn', value: '供应商名称' },
            //         { prop: 'supplierCode', value: '供应商编码' }
            //     ],
            //     tableConfig: [
            //         { prop: 'supplierNameCn', value: '供应商名称' },
            //         { prop: 'supplierCode', value: '供应商编码' },
            //         { prop: 'transNameListStr', value: '采购渠道' }
            //     ],
            //     method: 'post',
            //     prefix: '/api-tms',
            //     advanceUrl: '/srm/supplier/search',
            //     type: 'advance',
            //     advanceNotSearch: true,
            //     queryConditionRequired: true,
            //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transTypeListStr#transType', 'transNameListStr#tranName'],
            //     advanceCascade: 'supplierCode#carrierCode',
            //     unfold: true,
            //     span: 4
            // },
            {
                name: '收款确认状态',
                value: 'confirmStatus',
                type: 'select',
                optionNum: 'DRIVER_EXPENSE_CONFIRM_STATUS',
                options: [],
                span: 3,
                unfold: true
            },
            {
                name: '确认状态推送BMS',
                value: 'pushBmsFlag',
                type: 'select',
                optionNum: 'PUSH_BMS_FLAG',
                options: [],
                span: 3,
                unfold: true
            },
            {
                name: '是否超期确认',
                value: 'isOverConfirm',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'true' },
                    { label: '否', value: 'false' }
                ],
                unfold: true,
                span: 3
            },
            {
                name: '发车单完成时间',
                value: 'completionTime',
                startTime: 'dispatchCompletionTimeStart',
                endTime: 'dispatchCompletionTimeEnd',
                startPlaceholder: '发车单完成开始日期',
                endPlaceholder: '发车单完成结束日期',
                type: 'time',
                timeNum: 30,
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftWidth: 120,
        selectBtn: true,
        leftOperation: false,
        columns: [
            {
                label: '序号',
                width: 80,
                prop: 'index',
                sort: true
            },
            {
                label: '专业公司',
                width: 150,
                prop: 'professionalCompany',
                sort: true
            },
            {
                label: '分公司名称',
                width: 150,
                prop: 'companyName',
                sort: true
            },
            {
                label: '服务平台名称',
                width: 150,
                prop: 'siteName',
                sort: true
            },
            {
                label: '发车单号',
                width: 150,
                prop: 'dispatchNo',
                sort: true
            },
            {
                label: '发车单创建时间',
                width: 150,
                prop: 'dispatchCreateTime',
                sort: true
            },
            {
                label: '发车单发车时间',
                width: 150,
                prop: 'dispatchTime',
                sort: true
            },
            {
                label: '发车单抵达时间',
                width: 150,
                prop: 'arrivalTime',
                sort: true
            },
            {
                label: '发车单完成时间',
                width: 150,
                prop: 'completionTime',
                sort: true
            },
            {
                label: '供应商编码',
                width: 150,
                prop: 'carrierCode',
                sort: true
            },
            {
                label: '供应商名称',
                width: 150,
                prop: 'carrierName',
                sort: true
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                width: 200,
                sort: true
            },
            {
                label: '司机名称',
                prop: 'driver',
                width: 150,
                sort: true
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                width: 150,
                sort: true
            },
            {
                label: '司机应收款日期',
                prop: 'receivableTime',
                width: 150,
                sort: true
            },
            {
                label: '司机收款时长',
                prop: 'paymentDate',
                width: 150,
                sort: true
            },
            {
                label: '时长来源',
                prop: 'durationSource',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '系统默认值', value: '1' },
                    { label: '供应商配置', value: '2' }
                ],
                width: 150,
                sort: true
            },
            {
                label: '是否超期确认',
                prop: 'isOverConfirm',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'true' },
                    { label: '否', value: 'false' }
                ],
                width: 150,
                sort: true
            },
            {
                label: '账单付款日期',
                prop: 'billPaymentDate',
                width: 150,
                sort: true
            },
            {
                label: '司机收款确认状态',
                width: 150,
                prop: 'confirmStatus',
                type: 'select',
                optionNum: 'DRIVER_EXPENSE_CONFIRM_STATUS',
                options: [],
                sort: true
            },
            {
                label: '司机确认凭证',
                width: 150,
                prop: 'photos',
                type: 'button',
                sort: true
            },
            {
                label: '费用确认时间',
                width: 150,
                prop: 'confirmTime',
                sort: true
            },
            {
                label: '收款确认人',
                prop: 'confirmRole',
                width: 150,
                sort: true
            },
            {
                label: '费用确认渠道',
                width: 150,
                prop: 'sourceType',
                type: 'select',
                optionNum: 'COST_SOURCE_TYPE',
                options: [],
                sort: true
            },
            {
                label: '运费异常反馈',
                width: 150,
                prop: 'exceptionFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: '1' }
                ],
                sort: true
            },
            {
                label: '运费异常反馈时间',
                width: 150,
                prop: 'exceptionTime',
                sort: true
            },
            {
                label: '车牌号',
                width: 150,
                prop: 'vehicleCard',
                sort: true
            },
            {
                label: '异常申诉审批',
                width: 150,
                prop: 'iflowStatusName',
                type: 'button',
                sort: true
            },
            {
                label: '确认状态推送BMS',
                width: 160,
                prop: 'pushBmsFlagName',
                type: 'button',
                sort: true
            }
        ],
        action: []
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            name: '发车单号',
            value: 'dispatchNo',
            type: 'input',
            span: 3
        },
        {
            name: '分公司',
            advanceLabel: '分公司',
            value: 'companyName',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                { prop: 'escoCompanyNo', 'value': '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNo', 'value': '分公司编码' },
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' }
            ],
            advanceUrl: '/searchBrand',
            type: 'advance',
            cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
            span: 3
        },
        {
            name: '服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            advanceUrl: '/searchPlatform',
            type: 'advance',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            span: 3
        },
        {
            name: '专业公司',
            value: 'professionalCompany',
            type: 'select',
            options: [],
            optionNum: 'JD_PROFESSIONAL_COMPANY'
        },
        {
            name: '司机编码',
            value: 'driverNo',
            type: 'input'
        },
        {
            name: '司机手机',
            value: 'driverContactWay',
            type: 'input'
        },
        {
            name: '有无申诉',
            value: 'isAppeal',
            type: 'select',
            optionNum: '',
            options: [
                { label: '有', value: 'true' },
                { label: '无', value: 'false' }
            ]
        },
        {
            name: '申诉审批结果',
            value: 'iflowStatus',
            type: 'select',
            optionNum: 'OTP_APPLY_STATUS',
            options: []
        },
        {
            name: '发车单创建时间',
            value: 'createTime',
            startTime: 'dispatchCreateTimeStart',
            endTime: 'dispatchCreateTimeEnd',
            startPlaceholder: '发车单创建开始日期',
            endPlaceholder: '发车单创建结束日期',
            type: 'time'
        },
        {
            name: '运费异常反馈',
            value: 'exceptionFlag',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: '1' },
                { label: '否', value: '0' }
            ]
        }
    ]
};
